import React from 'react';
import { theme } from 'theme';

const textVariantObj = {
    dark: theme.textColor.heading,
    light: theme.textColor.headingLight,
    muted: theme.textColor.muted,
    blue: '#4db8d3'
};

interface Props {
    style?: object;
    children: string | object;
    textVariant?: 'dark' | 'light' | 'blue';
    mb?: number;
    mt?: number;
    pb?: number;
    pt?: number;
}

export const H3 = (
    {
        children,
        textVariant,
        mb,
        pb,
        mt,
        pt,
        ...props
    }: Props) => {
    const atomStyles = {
        mb: theme.spacing[mb] || '0px',
        mt: theme.spacing[mt] || '0px',
        pb: theme.spacing[pb] || '0px',
        pt: theme.spacing[pt] || '0px',
        color: !textVariant ? theme.textColor.heading : textVariantObj[textVariant]
    };

    return (
        <h3 data-comp={H3.displayName} {...props}>
            <>
                {children}
            </>
            <style jsx>{`
                h3 {
                    margin-top: ${atomStyles.mt};
                    margin-bottom: ${atomStyles.mb};
                    padding-top: ${atomStyles.pt};
                    padding-bottom: ${atomStyles.pb};
                    color: ${atomStyles.color};
                    font-family: ${theme.font.primary};
                    font-size: 39.06px;
                    line-height: 42.96px;
                    @media (max-width: 575.98px) {
                        font-size: 31.25px;
                        line-height: 37.5px;
                    }
                }
            `}</style>
        </h3>
    );
};

H3.displayName = 'H3';
